import React from 'react'
import { Flex } from 'components/Layout'
import Link from 'components/Link'
import { Text } from 'components/Typography'
import { PURCHASE_TERMS_SLUG, RETURN_POLICY_SLUG } from 'constants/common'
import { ROUTE } from 'constants/routes'
import { FONT_SIZE, FONT_WEIGHT, SPACE } from 'Theme'

interface ReturnPolicyProps {
  isItemWithReturnNotEligible?: boolean
}

export const ReturnPolicy: React.FC<React.PWC<ReturnPolicyProps>> = ({
  isItemWithReturnNotEligible = false,
}) => (
  <Flex flexDirection="column" pt={SPACE.PX_8} gap={SPACE.PX_10}>
    <Text fontSize={FONT_SIZE.PX_14} fontWeight={FONT_WEIGHT.MEDIUM}>
      Cancellation and Return Policy
    </Text>
    {isItemWithReturnNotEligible && (
      <Text fontSize={FONT_SIZE.PX_12}>
        One or more items on the order are final sale and cannot be returned.
      </Text>
    )}
    <Text fontSize={FONT_SIZE.PX_12}>
      For more information please read our{' '}
      <Link
        href={ROUTE.BLOG_DETAIL({ slug: PURCHASE_TERMS_SLUG })}
        isExternal
        fontSize={FONT_SIZE.PX_12}
      >
        Purchase Terms and Conditions
      </Link>{' '}
      and{' '}
      <Link
        href={ROUTE.BLOG_DETAIL({ slug: RETURN_POLICY_SLUG })}
        isExternal
        fontSize={FONT_SIZE.PX_12}
      >
        Return Policy
      </Link>
      .
    </Text>
  </Flex>
)
